import React, { useEffect, useContext, useRef, useState, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { ApiService } from "../../Component/services/apiServices";
import { BrowserView, MobileView } from "react-device-detect";
import { Navigation, Pagination } from "swiper/modules";
import { Autoplay } from "swiper/modules";
import Header from "../../Component/Header";
import Footer from "../../Component/Footer";
import AccountHeader from "../../Component/Header/account_header";
import { Swiper, SwiperSlide } from 'swiper/react';
import DataContext from "../../Component/context";
import './cateringStyle.css'
import CateringBookingModal from "./Modal/cateringBookingModal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
function CateringPlansSection() {
    const navigate = useNavigate();
    const didMountRef = useRef(true)

    const [cateringPackage, setCateringPackage] = useState([])
    const contextValues = useContext(DataContext);
    const isOrderStop = contextValues?.settingData?.order_stop == 1 || contextValues?.settingData?.order_stop === true;
    const [UserData, setUserData] = useState({});
    const swiperModules = useMemo(() => [Autoplay, Pagination, Navigation], []);

    const closeCateringModal = () => {
        contextValues.setToggleCateringModal(false);
    };

    const cateringModal = (slug, date) => {
        const cateringData = {
            product_slug: slug,
            activeDay: date
        }
        contextValues.setSelectedCateringMenu(cateringData)
        contextValues.setToggleCateringModal(!contextValues.toggleCateringModal)
    }

    const [selectedDates, setSelectedDates] = useState({});

    const handleDateChange = (productId, date) => {
        setSelectedDates((prev) => ({
            ...prev,
            [productId]: date,
        }));
    };

    const dateRefs = useRef({});
    const openDatePicker = (productId) => {
        const input = dateRefs.current[productId];

        if (input?.showPicker) {
            input.showPicker();
        } else {
            input?.click();
        }
    };

    const fetchCateringPackages = useCallback(() => {
        ApiService.fetchData("cateringMenuList").then((res) => {
            if (res?.status === "success") {
                setCateringPackage(res?.resCateringMenuList);
            }
        }).catch((error) => {

        });
    }, []);

    useEffect(() => {
        if (didMountRef.current) {
            fetchCateringPackages();
        }
        didMountRef.current = false;
    }, [])

    const noticeMessages = {
        0: "✓ 20 Minutes Notice Required",
        1: "✓ 5 Hours Notice Required",
        2: "✓ 8 Hours Notice Required",
        3: "✓ 10 Hours Notice Required",
        4: "✓ Minimum 1 Day Advance Booking",
        5: "✓ Minimum 2 Days Advance Booking",
        6: "✓ Minimum 1 Week Advance Booking"
    };
    return (
        <>
            <div className="plans-section">
                {isOrderStop && contextValues?.settingData?.order_stop_message && (<div className="alert alert-warning text-center mb-3" role="alert" style={{ whiteSpace: 'pre-line' }}>{contextValues.settingData.order_stop_message}</div>)}
                <div>
                    <p className="section-label">Catering Packages</p>
                    <h2 className="section-mtitle">Choose your catering experience</h2>
                </div>
                <div className="plans-grid">
                    {cateringPackage.map((item, index) => {
                        const selectedDate = selectedDates[item.product_id] || moment().format("YYYY-MM-DD");
                        return (
                            <div className={`plan-card ${item.product_type == 1 && 'featured'}`} key={index}>
                                {index == 1 && <>
                                    <span className="plan-crown">👑 Most Popular</span>
                                </>
                                }
                                <h3 className="plan-name">{item.product_name}</h3>
                                <p className="plan-tagline">{item.product_short_desc1}</p>
                                <div className="notice-badge">
                                    {noticeMessages[Number(item.product_notice)] || ""}
                                </div>

                                <p className="plan-price-label">Price</p>
                                <p className="plan-price">${item.product_selling_price} / Per Person</p>
                                <div className="plan-divider"></div>
                                <div className="date-row">
                                    <p className="date-label">Select Your Event Date</p>

                                    <DatePicker
                                        selected={
                                            selectedDates[item.product_id]
                                                ? new Date(selectedDates[item.product_id])
                                                : new Date()
                                        }
                                        minDate={new Date()}
                                        dateFormat="dd/MM/yyyy"
                                        onChange={(date) => {
                                            const formattedDate = moment(date).format("YYYY-MM-DD");

                                            setSelectedDates((prev) => ({
                                                ...prev,
                                                [item.product_id]: formattedDate,
                                            }));

                                            handleDateChange(item.product_id, formattedDate);
                                        }}
                                        customInput={
                                            <div className="date-input">
                                                {selectedDates[item.product_id]
                                                    ? moment(
                                                        selectedDates[item.product_id]
                                                    ).format("DD/MM/YYYY")
                                                    : moment().format("DD/MM/YYYY")}
                                                <span>📅</span>
                                            </div>
                                        }
                                    />
                                </div>
                                <ul className="plan-feature-list">
                                    {item.product_highlight &&
                                        JSON.parse(item.product_highlight).map((highlight, idx) => (
                                            <li key={idx}>
                                                <span className="check-icon">✓</span>
                                                {highlight}
                                            </li>
                                        ))}
                                </ul>
                                <div className="plan-note">{item.product_short_desc2}</div>
                                <a href="#" onClick={(e) => { e.preventDefault(); cateringModal(item.product_slug, selectedDate) }} className={`plan-cta ${item.product_type == 1 ? 'solid-gold' : 'outline'}`}>{item.product_type == 1 ? 'Request a Quote' : 'Select Menu'}</a>
                            </div>
                        )
                    })}
                </div>
            </div>
            {contextValues.toggleCateringModal && (<CateringBookingModal />)}
        </>
    )
}

export default CateringPlansSection